module.exports = __webpack_public_path__ + "media/images/heart-9c54f3d1477460985c2aa72cbb181539.svg";